import React, { useState } from 'react'

const SettingsSection = ({ title, children, variant = 'default', className = "", defaultOpen = true }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  const getVariantStyles = () => {
    switch (variant) {
      case 'danger':
        return {
          titleClass: 'text-red-400',
          containerClass: 'bg-red-500/10 border-red-500/20'
        }
      default:
        return {
          titleClass: 'var(--theme-text-primary)',
          containerClass: 'bg-white/5 border-white/10'
        }
    }
  }

  const { titleClass, containerClass } = getVariantStyles()

  return (
    <div className={`mb-8 ${className}`}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between text-2xl font-semibold mb-4 hover:opacity-80 transition-opacity"
        style={variant !== 'danger' ? {color: titleClass} : {}}
      >
        <h2 className={variant === 'danger' ? 'text-red-400' : ''}>
          {title}
        </h2>
        <svg
          className={`w-6 h-6 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          style={variant !== 'danger' ? {color: titleClass} : {}}
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {isOpen && (
        <div className={`rounded-xl p-6 border ${containerClass}`}>
          {children}
        </div>
      )}
    </div>
  )
}

export default SettingsSection